import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { change_password, setChangePasswordOpen } from "../../../store/user/userSlice";

const mapStateToProps = (state) => {
  const { is_open,company_details} = state.user;
  return {
    is_open : is_open,
    company_details : company_details
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
    change_password,
    setChangePasswordOpen
  }, dispatch);

const Store = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);

export default Store;
